module.exports = __webpack_public_path__ + "img/back-arrow.8a29cc0d.svg";